/* eslint-disable prefer-template */
import JsBarcode from 'jsbarcode';
import pdf417 from 'pdf417-generator';

export const contentTag = ({ tagData, pickupData, tagHasAlreadyPrinted }) => {
  const content = [];

  let firstNode = true;

  tagData?.forEach(({ invoiceNumber, fileUrl, tags }) => {
    tags?.forEach((value, index) => {
      const headlineLevel = firstNode ? 0 : 1;

      firstNode = false;

      const code = value?.barCode;

      const canvasPdf417 = document.createElement('canvas');

      pdf417.draw(code + code + code + code, canvasPdf417, 2, -1, 2);

      const xmlSerializer = new XMLSerializer();

      const svgNode = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg'
      );

      JsBarcode(svgNode, code, {
        xmlDocument: document,
        format: 'CODE128C',
        fontSize: 16,
        width: 1.5,
        height: 60
      });

      const svgBarCode = xmlSerializer.serializeToString(svgNode);

      content.push({
        headlineLevel,
        table: {
          widths: [124, 254],
          body: [
            [
              {
                layout: 'noBorders',
                table: {
                  widths: ['*'],
                  body: [
                    [
                      {
                        qr: fileUrl,
                        fit: 130,
                        margin: [8, 8, 8, 2]
                      }
                    ],
                    [
                      {
                        text: 'DOCUMENTOS',
                        margin: -4,
                        alignment: 'center',
                        fontSize: 9,
                        bold: true
                      }
                    ]
                  ]
                }
              },
              {
                // layout: 'noBorders',
                table: {
                  widths: ['*', '*', '*'],
                  body: [
                    [
                      {
                        text: 'BRASPRESS',
                        margin: -4,
                        alignment: 'center',
                        style: 'header',
                        colSpan: 3
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: value?.destination || '-',
                        margin: -2,
                        fillColor: '#000000',
                        color: '#ffffff',
                        alignment: 'center',
                        style: 'header'
                      },
                      {
                        text: String(
                          'Rota\r\n' + value.routeDescription || '-'
                        ),
                        margin: -2,
                        fillColor: '#000000',
                        color: '#ffffff',
                        bold: true
                      },
                      {
                        text: 'Rota Sec',
                        margin: [8, -2, 0, 0],
                        bold: true
                      }
                    ],
                    [
                      {
                        text: 'Destino',
                        alignment: 'center',
                        fontSize: 9,
                        bold: true,
                        border: [0]
                      },
                      {
                        text: '',
                        border: [0]
                      },
                      {
                        text: '',
                        border: [0]
                      }
                    ],
                    [
                      {
                        text: ' ',
                        fillColor: '#000000',
                        color: '#ffffff',
                        bold: true,
                        colSpan: 2
                      },
                      {
                        text: '',
                        border: [0]
                      },
                      {
                        text: '',
                        border: [0]
                      }
                    ],
                    [
                      {
                        text: 'Origem/Frota',
                        fontSize: 9,
                        bold: true
                      },
                      {
                        text: 'Viagem Célula',
                        alignment: 'center',
                        fontSize: 9,
                        bold: true
                      },
                      {
                        text: String(value?.shipping || '-'),
                        alignment: 'center',
                        bold: true
                      }
                    ],
                    [
                      {
                        text: String(pickupData?.branchSenderInitials || '-'),
                        fillColor: '#000000',
                        color: '#ffffff',
                        bold: true
                      },
                      {
                        text: '',
                        fillColor: '#000000',
                        color: '#ffffff',
                        alignment: 'center',
                        bold: true
                      },
                      {
                        text: '',
                        fillColor: '#000000',
                        color: '#ffffff',
                        alignment: 'center',
                        bold: true
                      }
                    ]
                  ]
                }
              }
            ]
          ]
        }
      });

      content.push({
        table: {
          widths: [189, 189],
          body: [
            [
              {
                layout: 'noBorders',
                table: {
                  widths: ['*', '*', '*'],
                  body: [
                    [
                      {
                        text: 'Remetente',
                        fillColor: '#000000',
                        color: '#ffffff',
                        alignment: 'center',
                        fontSize: 9,
                        bold: true
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: String(pickupData?.senderCorporationName || '-'),
                        fontSize: 9,
                        bold: true,
                        colSpan: 3
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: 'Destinatário',
                        fillColor: '#000000',
                        color: '#ffffff',
                        alignment: 'center',
                        fontSize: 9,
                        bold: true
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: String(value?.receiverCorporationName || '-'),
                        fontSize: 9,
                        bold: true,
                        colSpan: 3
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: String(value?.receiverFullAddress || '-'),
                        fontSize: 9,
                        bold: true,
                        colSpan: 3
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: '',
                        fontSize: 9,
                        bold: true,
                        colSpan: 3
                      },
                      '',
                      ''
                    ],
                    [
                      {
                        text: '',
                        fontSize: 9,
                        bold: true,
                        colSpan: 3
                      },
                      '',
                      ''
                    ]
                  ]
                }
              },
              {
                image: String(canvasPdf417.toDataURL()),
                alignment: 'center',
                width: 180
              }
            ]
          ]
        }
      });

      content.push({
        table: {
          widths: [387],
          body: [
            [
              {
                svg: svgBarCode,
                alignment: 'center',
                border: [1, 0, 1, 0]
              }
            ]
          ]
        }
      });

      content.push({
        table: {
          widths: ['auto', 307, 62],
          body: [
            [
              {
                text: '',
                fillColor: '#ffffff',
                color: '#ffffff',
                alignment: 'justify',
                fontSize: 9,
                bold: true,
                border: [1]
              },
              {
                text: '',
                border: [0]
              },
              {
                text: String(tagHasAlreadyPrinted ? 'REIMPRESSÃO' : ''),
                fontSize: 9,
                bold: true,
                border: [0, 0, 1, 0]
              }
            ]
          ]
        }
      });

      content.push({
        table: {
          widths: [20, 94, 20, 94, 20, 94],
          body: [
            [
              {
                text: 'Vol:',
                fillColor: '#000000',
                color: '#ffffff',
                alignment: 'justify',
                fontSize: 9,
                bold: true
              },
              {
                text:
                  // eslint-disable-next-line prettier/prettier
                  String(index + 1).padStart(4, '0') + '/' + String(tags.length).padStart(4, '0')
              },
              {
                text: 'Obs:',
                fillColor: '#000000',
                color: '#ffffff',
                alignment: 'justify',
                fontSize: 9,
                bold: true
              },
              {
                text: ''
              },
              {
                text: 'NF:',
                fillColor: '#000000',
                color: '#ffffff',
                alignment: 'justify',
                fontSize: 9,
                bold: true
              },
              {
                text: String(invoiceNumber || '-')
              }
            ]
          ]
        }
      });

      content.push({
        table: {
          widths: [387],
          body: [
            [
              {
                text: ' ',
                border: [1, 0, 1, 1]
              }
            ]
          ]
        }
      });
    });
  });

  return {
    styles: {
      header: {
        fontSize: 22,
        bold: true
      }
    },
    pageSize: 'A5',
    pageMargins: [0, 0, 0, 0],
    content,
    pageBreakBefore(currentNode) {
      return currentNode.headlineLevel === 1;
    }
  };
};
